const COLORS = [
  '#CCFF33',
  '#FF821C',
  '#D68CFF',
  '#5DFFC5',
  '#FFEA00',
  '#FF4EB8',
  '#3AE5FF',
  '#FF6767'
];

export const getRandomBackgroundColor = () => {
  return COLORS[Math.floor(Math.random() * COLORS.length)];
};
